<template>
	<div class="modal-confirm-logout">
		<div class="bg" v-tap="close"></div>
		<div class="content">
			<div class="title">Quitter le mini-jeu</div>
			<div class="question">
				<p>En quittant le mini-jeu, ta progression ne sera pas sauvegardée.</p>
				<p><strong>Souhaites-tu quitter le mini-jeu?</strong></p>
			</div>
			<div class="answers">
				<ui-button color="red" block="true" v-tap="close">Non, continuer</ui-button>
				<ui-button color="green" block="true" v-tap="leave">Oui, quitter</ui-button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		popup: { default: null }
	},
	methods: {
		leave() {
			this.$router.push({ name: 'city' })
			this.close()
		},
		close() {
			this.$emit('close')
		}
	},
}
</script>

<style lang="stylus" scoped>

.modal-confirm-logout
	absolute 0
	flex center
	.bg
		absolute 0
	> .content
		width calc(100vw - 32px)
		max-width 520px
		padding 32px
		flex center column
		gap 48px
		// background-color #eee
		border-radius 8px
		color #fff
		font-size 2rem
		text-align center
		.title
			width 100%
			margin 0 0 16px 0
			font-size 3.2rem
			border-bottom 3px solid blue
		.question
			width 100%
			flex center column
			gap 16px
			> p
				width 100%
				strong
					font-weight 500
		.answers
			width 100%
			flex center
			gap 16px
		
	
</style>
